export default __webpack_public_path__ + "static/media/no_user.8fd4cf5d.png";